export const CONFIG_URL =
  "https://api.skalillc.com/safeair-backend-api-configuration-provider";
export const API_KEY = "HgKOabhp8q9J4yROPICxt4OwpYxSvOKWaKkMTYCs";
export const IDENTITY_APIs = {
  login: "/token",
};
export const FLIGHT_APIS = {
  ListFlights: "/api/flight",
};

export const PASSENGER_APIS = {
  ListPassengers: "/api/passenger",
};

export const FLIGHT_PASSENGER_APIS = {
  ListAllFlightPassengersByFlightId: "/api/flight/passenger?flightId=$flightId",
};
